module.exports = __webpack_public_path__ + "img/pic-paging-service-3-2.a96daf2d.jpg";